module.exports = __webpack_public_path__ + "img/employee.ac5ded84.jpg";